import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { gutil } from '../../gutil';
import { faUserCircle, faFile, faTimes} from '@fortawesome/free-solid-svg-icons';
import { Router } from "@angular/router";

@Component({
  selector: 'app-room-alloc-and-profile',
  templateUrl: './room-alloc-and-profile.component.html',
  styleUrls: ['./room-alloc-and-profile.component.scss']
})
export class RoomAllocAndProfileComponent implements OnInit {

  public faUserCircle = faUserCircle;
  public faFile = faFile;
  public faTimes = faTimes;
  public tenantProp:Array<any>;
  public show:any;
  public isChecked: boolean = true;
  public roomAF:boolean;
  public checkBtn:any;
  public agreePolicy:any;
  public user:any;
  public isRAButtonDisabled: boolean = true;
  public isEditProfileDisabled: boolean = false;
  
  constructor(private http:HttpClient,private router: Router) { }

  ngOnInit(): void {
    window.scroll(0,0);
    this.user = gutil.user;
    this.fetch_roomAllocData();
    this.enableRoomAllocation();
  }
  public enableRoomAllocation() {
     if(this.user.name!=""&&this.user.email!=""&&this.user.phone!="" &&this.user.father_name!="" && this.user.mother_name!="" && this.user.addressl1!="" && this.user.zipcode!="" &&this.user.city!="" && this.user.state!="" && this.user.gender!="" && this.user.occupation!="" && this.user.nationality!="" && this.user.adhaar_number!="" && this.user.bank_account!=""&& this.user.bank_ifsc!=""){
      this.isRAButtonDisabled = false;
      this.isEditProfileDisabled = true;
     }else{
       this.isEditProfileDisabled = false;
       this.isRAButtonDisabled = true;
     }


  }
  public fetch_roomAllocData() {
    this.http.get(gutil.devapiUrl+'/api/v1/property/tenant/' + this.user.id +  '/dashboard?api_token=' + this.user.api_token)
        .subscribe((data:any) => {
          this.tenantProp = data.obj;
        })
  }
  
  public submitRaForm() {
    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    let options =  {headers: headers };
    let params = new URLSearchParams();
    
    params.append('user_id', this.user.id);
    params.append('room_id',this.tenantProp[0].room_id); 
    params.append('property_id',this.tenantProp[0].property_id);
    params.append('puid',this.tenantProp[0].id);
    params.append('Confirmation',"1");

    let paramsString = params.toString();
    
    this.http.post(gutil.devapiUrl + '/api/w/v1/submit/RoomAllocationForm', paramsString, options)
      .subscribe((data:any) => {
        console.log("Success");
        setTimeout(() => {
          this.router.navigate(['profile/tenant']).then(() => {
            window.location.reload();
          })
        },1000)
      });
  }
  showRaformHideSubmit($event: any) {
    if(this.isChecked) { 
      this.checkBtn = true;
    }
    else  {
      this.checkBtn = false;
    }
  }
}
